import styled from 'styled-components';

export const Box = styled.div`
	box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
	margin-top: ${props => props.marginTop || null};
	border-radius: ${props => props.borderRadius || null};
	padding: ${props => props.padding || null};
`;
